'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './page-list.routes';

export class AdminPageListComponent {
  constructor(Auth, DynamicPageService) {
    'ngInject';

    this.DynamicPageService = DynamicPageService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;

    this.DynamicPageService.query((data) => {
      this.data = data.filter(page => {
        return page.isAdminEditable == true;
      });
    }, err => {
      console.log("Could not retrieve dynamic pages.")
    })

  }
}

export default angular.module('conduuApp.adminPageList', [uiRouter])
  .config(routes)
  .component('adminPageList', {
    template: require('./page-list.html'),
    controller: AdminPageListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/page/list/page-list.component.js